// Client-side logo fetch for PDF generators (CORS + blob URL; skips SVG).

export async function resolveLogoSrc(url: string | null): Promise<string | null> {
  if (!url) return null;
  if (url.toLowerCase().endsWith(".svg")) return null;
  try {
    const r = await fetch(url, { mode: "cors" });
    if (!r.ok) return null;
    const ct = (r.headers.get("content-type") || "").toLowerCase();
    if (ct.includes("svg")) return null;
    if (!ct.includes("image/")) return null;
    const blob = await r.blob();
    return URL.createObjectURL(blob);
  } catch {
    return null;
  }
}

export function revokeIfBlobUrl(src: string): void {
  if (src.startsWith("blob:")) {
    try {
      URL.revokeObjectURL(src);
    } catch {
      // ignore
    }
  }
}
